
<div class="ui-messages ui-widget ui-messages-warn d-block p-1 m-0 border-0">
  <div class="d-flex align-items-center px-2 py-3">
    <p class="ui-messages-detail mb-0 pl-3">
      <strong>This url is no longer active. You need to login through</strong>
      <a href="http://www.desigual.biz" class="dgl-login-link">www.desigual.biz</a>
    </p>
  </div>
</div>
